/* pantallas-alumno (B): EL PUNTAJE (piezas nuevas de la parte 2; Historial y Analiticas).

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Tres niveles: alto con trofeo en verde #4ADE80, medio con palomita en naranja #F7A06A, bajo con
   tache en rojo #F87171. Los CORTES son los de hoy y los decide quien lo usa (pasa `nivel`): esta
   pieza solo pinta. Icono de 17 px y el numero de 15 px bold (renglon de sesion); `claseDelNumero`
   lo cambia donde el diseno pide otro tamano. `COLORES_DEL_PUNTAJE` sirve tambien para pintar solo el
   porcentaje (Topic Accuracy). */
import React from 'react';
import { Check, Trophy, X } from 'lucide-react';

export const COLORES_DEL_PUNTAJE = Object.freeze({ alto: '#4ADE80', medio: '#F7A06A', bajo: '#F87171' });
const ICONOS = { alto: Trophy, medio: Check, bajo: X };

export default function Puntaje({ nivel = 'medio', children, testid, className = '', claseDelNumero = 'text-[15px] font-bold tabular-nums', conIcono = true }) {
  const n = COLORES_DEL_PUNTAJE[nivel] ? nivel : 'medio';
  const Icono = ICONOS[n];
  return (
    <span data-testid={testid} data-nivel={n} className={`inline-flex items-center gap-1.5 shrink-0 ${className}`.trim()} style={{ color: COLORES_DEL_PUNTAJE[n] }}>
      {conIcono ? <Icono className="w-[17px] h-[17px] shrink-0" aria-hidden="true" /> : null}
      <span className={claseDelNumero}>{children}</span>
    </span>
  );
}
